import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';

import BookingListComponent from './booking-list-component';

import { getBookings } from '../bookings/actions';


const mapStateToProps = state => ({
  user: state.Dashboard.user,
  booking: state.Booking
});

const PAGE_SIZE = 10;

class BookingRenterComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      bookings: [],
      bookingsCount: 0,
      listingBookings: [],
      listingBookingsCount: 0,
      bookingType: ''
    }
  }

  componentWillMount() {
    let { dispatch } = this.props;
    dispatch(getBookings());
  }

  componentDidMount() {
    let { booking, user } = this.props;
    let { page } = this.state;
    let stateChanges = {};
    if (booking.bookings && booking.bookings.length > 0) {
      let filteredBookings = this.filterBookings(booking.bookings);
      stateChanges.bookingsCount = filteredBookings.length;
      if (filteredBookings.length > 0)
        stateChanges.bookings = this.paginateBookings(filteredBookings, page);
    }
    if (booking.listingBookings && booking.listingBookings.length > 0) {
      let filteredListingBookings = this.filterBookings(booking.listingBookings);
      stateChanges.listingBookingsCount = filteredListingBookings.length;
      if (filteredListingBookings.length > 0)
        stateChanges.listingBookings = this.paginateBookings(filteredListingBookings, page);
    }
    if (user) {
      stateChanges.bookingType = user.userType;
    }
    if (Object.keys(stateChanges).length !== 0) {
      this.setState(stateChanges);
    }
  }

  componentDidUpdate(oldProps, oldState) {
    let { booking } = this.props;
    let { page } = this.state;

    let pageChanged = oldState.page !== page;
    let bookingsChanged = oldProps.booking.bookings.length !== booking.bookings.length;
    let listingBookingsChanged = oldProps.booking.listingBookings.length !== booking.listingBookings.length;
    let stateChanges = {};
    if (booking.bookings.length > 0 && (pageChanged || bookingsChanged)) {
      let filteredBookings = this.filterBookings(booking.bookings);
      stateChanges.bookingsCount = filteredBookings.length;
      if (filteredBookings.length > 0)
        stateChanges.bookings = this.paginateBookings(filteredBookings, page);
    }
    if (booking.listingBookings.length > 0 && (pageChanged || listingBookingsChanged)) {
      let filteredListingBookings = this.filterBookings(booking.listingBookings);
      stateChanges.listingBookingsCount = filteredListingBookings.length;
      if (filteredListingBookings.length > 0)
        stateChanges.listingBookings = this.paginateBookings(filteredListingBookings, page);
    }
    if (!oldProps.user && this.props.user && !this.state.bookingType) {
      stateChanges.bookingType = this.props.user.userType;
    }
    if (Object.keys(stateChanges).length !== 0) {
      this.setState(stateChanges);
    }
  }

  paginateBookings(bookings, page) {
    let firstIndex = PAGE_SIZE * (page - 1);
    let lastIndex = (PAGE_SIZE * page);
    return bookings
      .sort(this.compareBookings)
      .slice(firstIndex, lastIndex)
  }

  filterBookings(bookings) {
    return bookings.filter(b => b.bookingRequestStatus === 'Accepted');
  }

  compareBookings(a, b) {
    let isSameOrAfter = moment(a.startDate).isSameOrAfter(moment(b.startDate));
    return isSameOrAfter ? -1 : 1;
  }

  setPage(i) {
    this.setState({ page: i });
  }

  bookingToggle(bookingType) {
    this.setState({ bookingType: bookingType, page: 1 });
  }

  renderPagination(page, itemCount) {
    let numberOfPages = Math.ceil(itemCount / PAGE_SIZE)
    let dom = [];
    dom.length = numberOfPages;
    dom = dom.fill(0).map((z, i) => {
      let classes = "d-inline";
      let j = i + 1;
      if (page === j) { classes = classes + " selected" }
      return (<div key={j} onClick={() => this.setPage(j)} className={classes}>{j}</div>);
    })
    return dom;
  }

  renderBookingToggle() {
    return (<div className="row booking-toggle"><div className="col">
      <span className={this.state.bookingType === 'owner' ? 'selected' : ''} onClick={() => this.bookingToggle('owner')}>As an <strong>owner</strong></span>
      <span className={this.state.bookingType !== 'owner' ? 'selected ml-3' : 'ml-3'} onClick={() => this.bookingToggle('renter')}>As a <strong>renter</strong></span>
    </div></div>)
  }

  render() {
    let { user, isMobile } = this.props;
    let { page, bookings, listingBookings, bookingType, bookingsCount, listingBookingsCount } = this.state;
    if (!user || !bookings) return (<div className="container text-center"><h4>Loading...</h4></div>)
    let bookingsToRender = bookingType === 'owner'
      ? listingBookings
      : bookings;
    let totalBookings = bookingType === 'owner'
      ? listingBookingsCount
      : bookingsCount;
    let pagination = this.renderPagination(page, totalBookings)
    return (<div className="container booking-container">
      <div className="row">
        <div className="col">
          {!isMobile && (<h2>Bookings</h2>)}
          {user.userType === 'owner' && this.renderBookingToggle()}
        </div>
      </div>
      <div className="row">
        <div className="col pagination-container">
          {pagination.length > 1 && pagination}
          <span>{pagination.length > 1 && (` | `)}{totalBookings} Total Bookings</span>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          {totalBookings === 0
            ? (<h5>No Bookings</h5>)
            : <BookingListComponent bookings={bookingsToRender} isOwner={bookingType === 'owner'} />}
        </div>
      </div>
      <div className="row">
        <div className="col pagination-container">
          {pagination.length > 1 && pagination}
          <span>{pagination.length > 1 && (` | `)}{totalBookings} Total Bookings</span>
        </div>
      </div>
    </div>);

  }
}

export default withRouter(connect(mapStateToProps)(BookingRenterComponent));
